import { render, staticRenderFns } from "./SpecimenDetail.vue?vue&type=template&id=00692f76"
import script from "./SpecimenDetail.vue?vue&type=script&lang=js"
export * from "./SpecimenDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports